<template>
  <div>
    <ul class="nav nav-tabs mb-2">
      <li class="nav-item">
        <router-link
          class="nav-link"
          :to="{ name: 'reports.tenders.list'}"
        >
          Leads List
        </router-link>
      </li>
      <li class="nav-item">
        <router-link
          :to="{ name: 'reports.tenders.opportunities'}"
          class="nav-link"
        >
          Opportunity
        </router-link>
      </li>
    </ul>
    <router-view />
  </div>
</template>
<script>
export default {}
</script>
